module.exports = __webpack_public_path__ + "img/choose02.e1e2695c.png";